import { render, staticRenderFns } from "./ThankYou.vue?vue&type=template&id=02b23b62&scoped=true&"
import script from "./ThankYou.vue?vue&type=script&lang=js&"
export * from "./ThankYou.vue?vue&type=script&lang=js&"
import style0 from "./ThankYou.vue?vue&type=style&index=0&id=02b23b62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b23b62",
  null
  
)

export default component.exports